export interface Testimonial {
  id: string;
  name: string;
  city: string;
  rating: number;
  reviewText: string;
  insuranceType: string;
  isFeatured: boolean;
  initials: string;
  avatarColor: string;
  datePublished: string;
}

export const testimonials: Testimonial[] = [
  {
    id: "1",
    name: "Rajesh Sharma",
    city: "Delhi",
    rating: 5,
    reviewText: "ExpertAdvise helped me find the perfect health insurance for my family. Their advisor took time to understand our needs and explained everything clearly. The claims support later was exceptional when my father needed surgery.",
    insuranceType: "Health Insurance",
    isFeatured: true,
    initials: "RS",
    avatarColor: "bg-blue-600",
    datePublished: "2025-01-15",
  },
  {
    id: "2",
    name: "Priya Patel",
    city: "Mumbai",
    rating: 5,
    reviewText: "I was completely confused about term insurance options. The team at ExpertAdvise compared 8 plans for me and recommended one that saved me 22% on premium while giving better coverage. Highly recommended!",
    insuranceType: "Term Insurance",
    isFeatured: true,
    initials: "PP",
    avatarColor: "bg-green-600",
    datePublished: "2025-02-20",
  },
  {
    id: "3",
    name: "Amit Gupta",
    city: "Bangalore",
    rating: 5,
    reviewText: "Their retirement planning service is top-notch. They created a complete roadmap for my retirement at 55, factoring in inflation, healthcare costs, and lifestyle needs. Very professional team.",
    insuranceType: "Retirement Planning",
    isFeatured: true,
    initials: "AG",
    avatarColor: "bg-amber-600",
    datePublished: "2025-03-10",
  },
  {
    id: "4",
    name: "Sneha Verma",
    city: "Noida",
    rating: 5,
    reviewText: "Got my corporate insurance for my startup through ExpertAdvise. They understood our budget constraints and still managed to get great coverage for all 25 employees. The onboarding was smooth.",
    insuranceType: "Group Health Insurance",
    isFeatured: true,
    initials: "SV",
    avatarColor: "bg-rose-600",
    datePublished: "2025-04-05",
  },
  {
    id: "5",
    name: "Vikram Reddy",
    city: "Hyderabad",
    rating: 5,
    reviewText: "When my car was damaged in an accident, their claims team handled everything. From documentation to follow-up with the insurer, they made the entire process stress-free. Got my claim settled in 12 days.",
    insuranceType: "Car Insurance",
    isFeatured: true,
    initials: "VR",
    avatarColor: "bg-indigo-600",
    datePublished: "2025-04-18",
  },
  {
    id: "6",
    name: "Meera Iyer",
    city: "Chennai",
    rating: 5,
    reviewText: "Started SIP investments through ExpertAdvise two years ago. My portfolio has grown 28% and their quarterly reviews keep me on track. They explain complex fund strategies in simple terms.",
    insuranceType: "SIP Investments",
    isFeatured: true,
    initials: "MI",
    avatarColor: "bg-teal-600",
    datePublished: "2025-05-08",
  },
];